export default "__VITE_ASSET__BvIt$$XB__"